import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/query-client';
import { useAuthStore } from './stores/auth.store';
import { AppRoutes } from './routes';
import { ErrorBoundary } from './components/ErrorBoundary';

export function App() {
  const restore = useAuthStore((state) => state.restore);
  const status = useAuthStore((state) => state.status);

  // On boot, trade the httpOnly refresh cookie for a live session. This is what makes
  // a page reload keep the user signed in without ever storing a token in the browser.
  useEffect(() => {
    if (status === 'idle') void restore();
  }, [status, restore]);

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
